export function formatCheck(value) {
    if (value)
        return <i className="fas fa-check"></i>;
    return <i className="fas fa-times"></i>;
}